import { IconProps } from './icon';
import React from 'preact/compat';

export const PlusIcon: React.FC<IconProps> = ({ title, role }) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      role={role}
    >
      {title && <title>{title}</title>}
      <path
        d="M11 5H7V1a1 1 0 00-2 0v4H1a1 1 0 000 2h4v4a1 1 0 002 0V7h4a1 1 0 000-2z"
        fill="currentColor"
        fill-rule="nonzero"
      ></path>
    </svg>
  );
};
